// extracted by mini-css-extract-plugin
module.exports = {"hidden":"forbiddenPage_hidden__24kh1","visible":"forbiddenPage_visible__2rOPo","block":"forbiddenPage_block__YwpYX"};